import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {TeamModel} from './team.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  tournamentCategoryId: 'tournamentCategoryId',
  eventId: 'eventId',
  teamId: 'teamId',
  rank: 'rank',
  points: 'points',
  matchesFor: 'matchesFor',
  matchesAgainst: 'matchesAgainst',
  setsFor: 'setsFor',
  setsAgainst: 'setsAgainst',
  gamesFor: 'gamesFor',
  gamesAgainst: 'gamesAgainst',

  team: 'team',
};

export class EventRankingModel extends Model {
  tournamentCategoryId!: number;
  eventId!: number;
  teamId!: number;
  rank!: number;
  points!: number;
  matchesFor!: number;
  matchesAgainst!: number;
  setsFor!: number;
  setsAgainst!: number;
  gamesFor!: number;
  gamesAgainst!: number;

  matchesPlayed?: number;
  team?: TeamModel;

  get avatarImg(): string {
    if (!this.team) {
      // Imagen por defecto
      return 'player.png';
    }

    const team: TeamModel = this.team;

    if (team.teamAvatar) {
      return String((team.teamAvatar % 30) + 1) + '.png';
    }

    if (team.playerAvatar) {
      return String((team.playerAvatar % 30) + 1) + '.png';
    }

    if (this.team?.name) {
      // Imagen por defecto del equipo
      return 'team.png';
    }

    // Imagen por defecto del jugador
    // @TODO: validar el genero del jugador para mostrar un avatar femenino
    // o masculino
    return 'player.png';
  }

  static getInstance(data: Params): EventRankingModel {
    const model = new EventRankingModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'team') {
        (model as Params)[prop] = TeamModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    model.matchesPlayed = model.matchesFor + model.matchesAgainst;

    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   eventId: number,
  //   urlParams?: HttpParams
  // ): Observable<ListState<EventRankingModel>> {
  //   return apiService
  //     .get(`tournaments/${eventId}/ranking`, urlParams)
  //     .pipe(
  //       map((data: Params): ListState<EventRankingModel> => {
  //         const list: EventRankingModel[] = data['data'].map((item: Params): EventRankingModel =>
  //           EventRankingModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
